import GooglePublisherTag from "components/shared/GooglePublisherTag/GooglePublisherTag";
import BannerAd from "components/shared/BannerAd/BannerAd";

window.GooglePublisherTag = GooglePublisherTag;
window.BannerAd = {
  getHermesEndpoint: BannerAd.getHermesEndpoint
}

const gptScript = document.getElementById('gpt-script');

window.__adsConfig = {
  enable_premier_user_banner_ads: gptScript.dataset.enablePremierUserBannerAds,
  leaderboard_refresh_interval: Number(gptScript.dataset.leaderboardRefreshInterval),
  top_banner_refresh_interval: Number(gptScript.dataset.topBannerRefreshInterval),
};

document.addEventListener('DOMContentLoaded', function() {
  GooglePublisherTag.setup();

  const lazyLoadOptions = {
    fetchMarginPercent: 0,
    renderMarginPercent: 0,
    mobileScaling: 1,
  };
  GooglePublisherTag.enableLazyLoad(lazyLoadOptions);
  GooglePublisherTag.enableServices();
});
